import AppTab from '../components/app-tab';

(function ($) {

  var topAnswersTab = null;


  function loadReactAppTab(topAnswersTab) {
    var tabNames = [];
    topAnswersTab.next().find('.tab-pane').each(function () {
      tabNames.push(this.getAttribute('data-title'));
    });

    $('.top-answers .ux-spinner').hide();

    ReactDOM.render(React.createElement(AppTab, {
      selector: '.top-answers .tab-pane',
      tabNames: tabNames
    }), topAnswersTab[0]);
  }

  function addCommunityDataTopContributor(contributor, idx) {

    var contributorUrl = contributor.userUrl.replace('www', requestContext.countrySite);
    var targetBlank = gdhelp2.utils.inIframe() ? ' target="_blank" ' : '';

    var itemHtml = '' +
    '<tr>' +
    '  <td class="table-item top-contributor-rank">' +
    '    <a href="' + contributorUrl + '"' + targetBlank + ' "title="' + contributor.userName +
    '" data-eid="mcx.help.home.top-contributor.click" data-tdata="item,' + idx +
    '^id,' + contributorUrl + '^plId,' + requestContext.plId + '">' +
    '      <h4 class="font-primary-bold text-primary">' + idx + '</h4>' +
    '    </a>' +
    '  </td>' +
    '  <td class="table-item top-contributor-avatar">' +
    '    <a href="' + contributorUrl + '"' + targetBlank +
    '    data-eid="mcx.help.home.top-contributor.click" data-tdata="item,' + idx +
    '^id,' + contributorUrl + '^plId,' + requestContext.plId + '">' +
    '      <div class="top-contributor-avatar-img">' +
    '        <img title="' + contributor.userName + '" alt="' + contributor.userName +
    '" src="' + contributor.userAvatar + '">' +
    '      </div>' +
    '    </a>' +
    '  </td>' +
    '  <td class="table-item top-contributor-name">' +
    '    <a href="' + contributorUrl + '"' + targetBlank + ' "title="' + contributor.userName +
    '" data-eid="mcx.help.home.top-contributor.click" data-tdata="item,' + idx +
    '^id,' + contributorUrl + '^plId,' + requestContext.plId + '">' +
    '      <h5>' + contributor.userName + '</h5>' +
    '    </a>' +
    '  </td>' +
    '</tr>';

    return itemHtml;
  }

  // eslint-disable-next-line id-length
  function loadCommunityDataTopContributors(topContributors) {
    var itemsHtml = '';
    $.each(topContributors, function (i, item) {
      itemsHtml += addCommunityDataTopContributor(item, i + 1);
    });
    $('#top-contributors-table').html(itemsHtml);
  }

  function addCommunityDataTopAnswer(item, idx, eventName) {

    var itemUrl = item.id.replace('www', requestContext.countrySite);
    var targetBlank = gdhelp2.utils.inIframe() ? ' target="_blank" ' : '';

    var itemHtml = '' +
    '<tr>' +
    '  <td class="table-item top-answer-title">' +
    '    <a href="' + itemUrl + '"' + targetBlank + ' title="' + item.htmlTitle +
    '" data-eid="' + eventName + '" data-tdata="item,' + idx +
    '^id,' + itemUrl + '^plId,' + requestContext.plId + '" class="hover-text-nav">' +
    '      <div class="top-answer-clickable">' +
    '        <p>' + item.htmlTitle + '</p>' +
    '      </div>' +
    '    </a>' +
    '  </td>' +
    '  <td class="table-item top-answer-arrow">' +
    '    <a href="' + itemUrl + '"' + targetBlank + ' title="' + item.htmlTitle +
    '" data-eid="' + eventName + '" data-tdata="item,' + idx +
    '^id,' + itemUrl + '^plId,' + requestContext.plId + '" class="hover-text-nav">' +
    '      <div class="top-answer-arrow-icon">' +
    '        <span class="uxicon uxicon-chevron-right-lt"></span>' +
    '      </div>' +
    '    </a>' +
    '  </td>' +
    '</tr>';

    return itemHtml;
  }

  function loadCommunityDataUnanswered(unanswered) {
    var itemsHtml = '';
    var eventName = 'mcx.help.home.unanswered.click';
    $.each(unanswered, function (i, item) {
      itemsHtml += addCommunityDataTopAnswer(item, i + 1, eventName);
    });
    $('#top-list-table-unanswered').html(itemsHtml);
  }

  function loadCommunityDataTopAnswers(topAnswers) {
    var itemsHtml = '';
    var eventName = 'mcx.help.home.top-answers.click';
    $.each(topAnswers, function (i, item) {
      itemsHtml += addCommunityDataTopAnswer(item, i + 1, eventName);
    });
    $('#top-list-table-top-answers').html(itemsHtml);
  }

  // eslint-disable-next-line id-length
  function communityTopSolutionsDataResponse(resp) {

    if (resp.status === 200 && resp.responseText) {
      var data = JSON.parse(resp.responseText);
      if (data && data.length) {
        var results = data[0];
        if (results.topContributors) {
          loadCommunityDataTopContributors(results.topContributors);
        }
        if (results.unanswered) {
          loadCommunityDataUnanswered(results.unanswered);
        }
        if (results.topAnswers) {
          loadCommunityDataTopAnswers(results.topAnswers);
        }
      }
    }

    loadReactAppTab(topAnswersTab);
  }

  // eslint-disable-next-line id-length
  function getCommunityTopSolutionsDataAsync() {
    var topSolutionsScope = requestContext.searchScopeStrId || 'All';
    var ajaxUrl = requestContext.hostPath + '/ajax';
    $.ajax({ url: ajaxUrl + '/communityTopSolutions?q=' + topSolutionsScope })
      .complete(communityTopSolutionsDataResponse);
  }

  function ready() {
    topAnswersTab = $('#top-answers-tab');
    if (topAnswersTab.length) {
      getCommunityTopSolutionsDataAsync();
    }
  }

  $(document).ready(ready);

}(jQuery));
